import { Injectable } from "@angular/core";
//import { GraphQLResult, generateClient } from 'aws-amplify/api';

//import { graphqlOperation } from '@aws-amplify/api-graphql';
import { AppConstants } from "./app-constants";
import { environment } from "../../../../../../environments/environment";
import {
  createFuelCreditQueries,
  createFuelMasterQueries,
  filterByFuelMaster,
  filterByFuelMasterQueries,
  getFuelCreditQueries,
  getFuelMasterQueries,
  updateFuelCardDetail,
  updateFuelCreditQueries,
  updateFuelMasterQueries,
  updateFuelMasterStatusQueries,
} from "../../graphql/fuel.queries";
import {
  FuelCreditModel,
  FuelMasterModel,
  InputFuelCredits,
  InputFuelDetails,
} from "../../model/fuelMaster.model";

// const client = generateClient();

import Amplify, { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "aws-amplify/lib/API/types";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { TableConstants } from "../../../../../constants/table-constants";
import { HttpUtilsService } from "../../../../../service/httputils.service";
let url = environment.pg_dburl[window.location.origin];
//const client = generateClient();

let myAppConfig = environment.myAppConfig;

Amplify.configure(myAppConfig);

@Injectable({
  providedIn: "root",
})
export class FuelcardService {
  created_date: string;
  updated_date: string;

  fuelCardCreditData = new BehaviorSubject(null);
  private basUrl = environment.smsUrl[window.location.origin];
  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {
    this.created_date = this.localDateFormate();
    this.updated_date = this.localDateFormate();
  }

  private QUERY_KEY = {
    Fuel_Master_LIST: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listFuelCardMaster}`,
    Fuel_Master_GET: `${AppConstants.getq}${environment.dbPrefix}${AppConstants.FuelMasterCard}`,
    Fuel_Master_CREATE: `${AppConstants.create}${environment.dbPrefix}${AppConstants.FuelMasterCard}`,
    Fuel_Master_UPDATE: `${AppConstants.update}${environment.dbPrefix}${AppConstants.FuelMasterCard}`,

    Fuel_Card_Detail_LIST: `${AppConstants.list}${environment.dbPrefix}${AppConstants.FuelCardDetails}`,
    Fuel_Card_Detail_GET: `${AppConstants.getq}${environment.dbPrefix}${AppConstants.FuelCardDetails}`,
    Fuel_Card_Detail_CREATE: `${AppConstants.create}${environment.dbPrefix}${AppConstants.FuelCardDetails}`,
    Fuel_Card_Detail_UPDATE: `${AppConstants.update}${environment.dbPrefix}${AppConstants.FuelCardDetails}`,

    Fuel_Credit_LIST: `${AppConstants.list}${environment.dbPrefix}${AppConstants.FuelCardCredit}`,
    Fuel_Credit_GET: `${AppConstants.getq}${environment.dbPrefix}${AppConstants.FuelCardCredit}`,
    Fuel_Credit_CREATE: `${AppConstants.create}${environment.dbPrefix}${AppConstants.FuelCardCredit}`,
    Fuel_Credit_UPDATE: `${AppConstants.update}${environment.dbPrefix}${AppConstants.FuelCardCredit}`,
  };

  localDateFormate() {
    // Assuming mydate is defined as a Date object
    const mydate = new Date();

    // Convert the date to ISO 8601 format including the local time zone offset
    const isoDateString = mydate.toISOString();

    // Alternatively, you can manually format the date string to include the local time zone offset
    const offset = -mydate.getTimezoneOffset(); // Get the offset in minutes
    const offsetHours = Math.floor(Math.abs(offset) / 60);
    const offsetMinutes = Math.abs(offset) % 60;
    const offsetSign = offset >= 0 ? "+" : "-";

    const formattedDateString = `${mydate.getFullYear()}-${this.padZero(
      mydate.getMonth() + 1
    )}-${this.padZero(mydate.getDate())}T${this.padZero(
      mydate.getHours()
    )}:${this.padZero(mydate.getMinutes())}:${this.padZero(
      mydate.getSeconds()
    )}${offsetSign}${this.padZero(offsetHours)}:${this.padZero(offsetMinutes)}`;
    console.log(formattedDateString); // Output: 2024-02-14T15:02:01+05:30
    return formattedDateString;
  }

  padZero(num: number): string {
    return num < 10 ? "0" + num : num.toString();
  }

  public async createFuelMasterCard(
    createdObj: any
  ): Promise<InputFuelDetails | null> {
    const tablename = TableConstants.FuelCardMaster;
    const endpoint = `${url}/${tablename}?select=*`;
    const payload = {
      data: {
        card_expiry_date: createdObj.card_expiry_date,
        card_number: createdObj.card_number,
        card_provider: createdObj.card_provider,
        status: AppConstants.REQUEST_STATUS.UNASSIGN,
        created_date: this.created_date,
        updated_date: this.updated_date,
      },
      created_date: this.created_date,
      updated_date: this.updated_date,
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error creating fuel master card:", error);
      throw error;
    }
  }

  public async updateFuelMasterCard(
    updateObj: any
  ): Promise<InputFuelDetails | null> {
    const functionName = TableConstants.fnUpdateFuelMasterCard;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: updateObj.id,
      updates: {
        card_expiry_date: updateObj.card_expiry_date,
        card_number: updateObj.card_number,
        card_provider: updateObj.card_provider,
        fuel_card_attachments: updateObj.fuel_card_attachments || [],
        status: AppConstants.REQUEST_STATUS.UNASSIGN,
        updated_date: this.updated_date,
      },
      p_updated_date: this.updated_date,
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error updating fuel master card:", error);
      throw error;
    }
  }
  public async getAllFuelCardMaster(
    offset: number = 0,
    limit: number = 100
  ): Promise<FuelMasterModel[]> {
    const tablename = TableConstants.FuelCardMaster;
    // const endpoint = `${url}/${tablename}?offset=${offset}&limit=${limit}`;
    const endpoint = `${url}/${tablename}`;
    try {
      const response = await this.httpUtils.get<FuelMasterModel[]>(endpoint);
      if (response) {
        console.log("FuelCardMaster REST response:", response);
        return response;
      } else {
        throw new Error("REST operation returned no data.");
      }
    } catch (error) {
      console.error("Error fetching Fuel Card master list:", error);
      throw error;
    }
  }

  public async createFuelCardDetails(
    createdObj: any
  ): Promise<InputFuelDetails | null> {
    const tablename = TableConstants.FuelCardDetail;
    const endpoint = `${url}/${tablename}?select=*`;
    const payload = {
      data: {
        employee_id: createdObj.employee_id,
        employee_name: createdObj.employee_name,
        fuel_card_id: createdObj.fuel_card_id,
        assigned_date: createdObj.assigned_date,
        // fuel_card_attachments: createdObj.fuel_card_attachments,
        status: AppConstants.REQUEST_STATUS.UNASSIGN,
        created_date: this.created_date,
        updated_date: this.updated_date,
      },
      created_date: this.created_date,
      updated_date: this.updated_date,
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error creating fuel card details:", error);
      throw error;
    }
  }

  public async updateFuelCardDetails(
    updateObj: any
  ): Promise<InputFuelDetails | null> {
    const functionName = TableConstants.fnUpdateFuelCardDetail;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: updateObj.id,
      updates: {
        employee_id: updateObj.employee_id,
        employee_name: updateObj.employee_name,
        fuel_card_id: updateObj.fuel_card_id,
        assigned_date: updateObj.assigned_date,
        // fuel_card_attachments: updateObj.fuel_card_attachments,
        status: AppConstants.REQUEST_STATUS.UNASSIGN,
        updated_date: this.updated_date,
      },
      p_updated_date: this.updated_date,
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error updating fuel card details:", error);
      throw error;
    }
  }

  public async filterByFuelCard(status: string): Promise<FuelMasterModel[]> {
    const tablename = TableConstants.FuelCardMaster;
    const endpoint = `${url}/${tablename}?data->>status=eq.${status}`;
    try {
      const response = await this.httpUtils.get<FuelMasterModel[]>(endpoint);
      if (response) {
        console.log("FuelCardMaster filter REST response:", response);
        return response;
      } else {
        throw new Error(
          "REST operation returned no data in filter from fuel master card."
        );
      }
    } catch (error) {
      console.error("Error fetching filter fuel card:", error);
      throw error;
    }
  }

  public async findFuelCardByCardNumber(
    cardNumber: string
  ): Promise<FuelMasterModel[]> {
    const tablename = TableConstants.FuelCardMaster;
    const endpoint = `${url}/${tablename}?data->>status=eq.ASSIGN&data->>card_number=eq.${cardNumber}`;
    try {
      const response = await this.httpUtils.get<FuelMasterModel[]>(endpoint);
      if (response) {
        console.log(
          "FuelCardMaster find by card number REST response:",
          response
        );
        return response;
      } else {
        throw new Error(
          "REST operation returned no data in filter from fuel master card."
        );
      }
    } catch (error) {
      console.error("Error fetching filter fuel card:", error);
      throw error;
    }
  }

  public async updateFuelMasterCardStatus(
    createdObj: any
  ): Promise<InputFuelDetails | null> {
    const functionName = TableConstants.fnUpdateFuelMasterCardStatus;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: createdObj.id,
      updates: {
        status: AppConstants.REQUEST_STATUS.INACTIVE,
        updated_date: this.updated_date,
      },
      p_updated_date: this.updated_date,
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error updating fuel master card status:", error);
      throw error;
    }
  }

  public async createFuelCardCredit(
    createdObj: any
  ): Promise<InputFuelCredits | null> {
    const tablename = TableConstants.FuelCardCredit;
    const endpoint = `${url}/${tablename}?select=*`;
    const payload = {
      fuel_card_id: createdObj.fuel_card_id,
      rnc_user_id: createdObj.rnc_user_id,
      data: {
        ...createdObj,
        created_date: new Date().toISOString(),
        updated_date: new Date().toISOString(),
      },
      created_date: new Date().toISOString(),
      updated_date: new Date().toISOString(),
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error creating fuel card credit:", error);
      return null;
    }
  }

  public async getAllFuelCardCredit(
    offset: number = 0,
    limit: number = 100): Promise<any> {
    const tablename = TableConstants.fngetFuelCardCredit;
    const endpoint = `${url}/${tablename}`;
    return this.httpUtils
      .get<any[]>(endpoint)
      .then((response) => {
        // Map each row to frontend schema
        const items = response.map((row) => {
          const item = { ...row.fuel_card_credit };
          item.fuelcard = row.fuelcard_detail;
          item.user = row.user_detail;
          return item;
        });
        return { items };
      });
  }

  public async findFuelCardByCardId(
    fuel_card_id: string
  ): Promise<FuelMasterModel[]> {
    const tablename = TableConstants.FuelCardMaster;
    const endpoint = `${url}/${tablename}?id=eq.${fuel_card_id}`;
    try {
      const response = await this.httpUtils.get<FuelMasterModel[]>(endpoint);
      if (response) {
        console.log(
          "FuelCardMaster find by id REST response:",
          response
        );
        return response;
      } else {
        throw new Error(
          "REST operation returned no data in filter from fuel master card."
        );
      }
    } catch (error) {
      console.error("Error fetching filter fuel card:", error);
      throw error;
    }
  }

  setFuelCardCreditData(data) {
    this.fuelCardCreditData.next(data);
  }

  public async updateFuelCardCredit(
    createdObj: any
  ): Promise<InputFuelCredits | null> {
    const functionName = TableConstants.fnUpdateFuelCardCredit;
    const endpoint = `${url}/${functionName}`;
    const payload = {
      p_id: createdObj.id,
      p_fuel_card_id: createdObj.fuel_card_id,
      p_rnc_user_id: createdObj.rnc_user_id,
      updates: {
        loading_value: createdObj.loading_value,
        loading_date: createdObj.loading_date,
        rn_number: createdObj.rn_number,
        updated_date: this.updated_date,
      },
      p_updated_date: this.updated_date,
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error updating fuel card credit:", error);
      return null;
    }
  }

  triggercreditEmail(payload: any) {
    this.http
      .post(this.basUrl + "/fuelcardcreditEmail/", payload)
      .subscribe((res) => {
        console.log("sendMail", res);
      });
  }

    public async getAllAssignFuelCardMaster(): Promise<any> {

    try {
        const functionName = TableConstants.FuelCardMaster;
        const params = `data->>status=eq.UNASSIGN`;
        const endpoint = `${url}/${functionName}?${params}`;
        const response = await this.httpUtils.get<FuelMasterModel[]>(endpoint);
        return response;
    } catch (error) {
      console.error('Error fetching Fuel Card request status:', error);
      throw error;
    }
  }

  async getAssignCarData() {
    const functionName = TableConstants.fngetCpAssignedCarQueries;
    const endpoint = `${url}/${functionName}`;
    try {
        const response = await this.httpUtils.get<any[]>(endpoint);
        const items = response.map((row) => {
          const item = { ...row.assigned_car };
          item.user = row.user_data;
          item.car = row.car_data;
          if (item.car) {
            item.car.agency = row.agency_data;
          }
          return item;
        });

        return items.filter((item) => item.status === 'ASSIGN');
    } catch (error) {
      console.error("Error fetching assigned car data:", error);
      throw error;
    }
  }

  async assignFuelCardToCar(payload: any): Promise<any> {
    const functionsName = TableConstants.updateAssignedCar;
    const endpoint = `${url}/${functionsName}`;
    const reqPayload = {
      p_id: payload.id,
      p_fuel_card_id: payload.fuel_card_id,
      updates: {
        fuel_card_id: payload.fuel_card_id,
        updated_date: this.updated_date,
      },
      p_updated_date: this.updated_date,
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, reqPayload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error assigning fuel card to car:", error);
      throw error;
    }
  }

  async getAssignedCarByFuelCardId(fuelCardId: string): Promise<any> {
    const functionName = TableConstants.fngetAssignCarByFuelCardId;
    const payload = {
      p_fuelid: fuelCardId,
    };
    const endpoint = `${url}/${functionName}`;
    try {
      const response = await this.httpUtils.post<any[]>(endpoint, payload);
      return response;
    } catch (error) {
      console.error("Error fetching assigned car by fuel card id:", error);
      throw error;
    }
  }


  async updateAssignedCarDetail(payload: any): Promise<any> {
    const functionsName = TableConstants.updateAssignedCar;
    const endpoint = `${url}/${functionsName}`;
    const reqPayload = {
      p_id: payload.id,
      p_fuel_card_id: null,
      updates: {
        fuel_card_id: null,
        updated_date: this.updated_date,
      },
      p_updated_date: this.updated_date,
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, reqPayload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error updating assign car data:", error);
      throw error;
    }
  }

  async blockFuelCard(fuelCardId: string): Promise<any> {
    const functionName = TableConstants.fnUpdateFuelMasterCardStatus;
    const endpoint = `${url}/${functionName}`;
    const reqPayload = {
      p_id: fuelCardId,
      updates: {
        status: "INACTIVE",
        updated_date: this.updated_date,
      },
      p_updated_date: this.updated_date,
    };

    try {
      const response = await this.httpUtils.post<any[]>(endpoint, reqPayload);
      return Array.isArray(response) && response.length > 0
        ? response[0]
        : null;
    } catch (error) {
      console.error("Error blocking fuel card:", error);
      throw error;
    }
  }
}
